import type { components } from "../../shared/api/generated/trading-engine.js";

type SystemStatus = components["schemas"]["SystemStatus"];
type DependencyStatus = components["schemas"]["DependencyStatus"];

export interface DependencyView {
  readonly details: Readonly<Record<string, string>>;
  readonly message: string;
  readonly name: DependencyStatus["name"];
  readonly status: DependencyStatus["status"];
}

export interface SystemStatusView {
  readonly checkedAt: string;
  readonly dependencies: readonly DependencyView[];
  readonly stale: boolean;
  readonly status: SystemStatus["status"];
}

function safeDetails(value: Record<string, unknown> | undefined): Readonly<Record<string, string>> {
  if (value === undefined) return {};
  const result: Record<string, string> = {};
  for (const [key, item] of Object.entries(value)) {
    if (/authorization|credential|password|secret|token/i.test(key)) continue;
    if (["boolean", "number", "string"].includes(typeof item)) result[key] = String(item);
  }
  return result;
}

export function systemStatusView(status: SystemStatus, now = Date.now()): SystemStatusView {
  const checkedAt = Date.parse(status.checkedAt);
  return {
    checkedAt: status.checkedAt,
    dependencies: status.dependencies.map((dependency) => ({
      details: safeDetails(dependency.details),
      message: dependency.message,
      name: dependency.name,
      status: dependency.status,
    })),
    stale: !Number.isFinite(checkedAt) || now - checkedAt > 60_000,
    status: status.status,
  };
}
